import { useQuery } from '@tanstack/react-query';

import { getUserMFADetails } from '@arrived/api_v2';
import { MfaDetails, UserId } from '@arrived/models';

import { UseQueryOptions, UseQueryResult } from '../../queries.utils';
import { userMFADetailsKeyFn } from './users.mfa.keys';

export function useGetMFADetailsQuery(
  userId?: UserId,
  options?: UseQueryOptions<MfaDetails>
): UseQueryResult<MfaDetails> {
  return useQuery(userMFADetailsKeyFn(userId!), () => getUserMFADetails(userId!), {
    ...options,
    enabled: (options?.enabled ?? true) && Boolean(userId),
  });
}
